"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _MainContent = _interopRequireDefault(require("./MainContent"));
var _ScrollSection = _interopRequireDefault(require("./ScrollSection"));
var _TableOfContents = _interopRequireDefault(require("./TableOfContents"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const addPlacementClass = (element, placement) => {
  switch (placement) {
    case 'auth':
      element.classList.add('nav-auth');
      return;
    case 'public':
      element.classList.add('nav-public');
      return;
    case 'consumer':
      element.classList.add('nav-mega');
      return;
    default:
      return;
  }
};
/**
 * ScrollSpy is a component that dynamically creates a Table of Contents
 * component separate from the provided children, and will scroll to specific
 * children when the items in the Table of Contents are clicked.
 *
 * ## Structure
 *
 * The dynamic construction of the Table of Contents relies on specific
 * attributes on each of the child elements provided to the ScrollSpy component:
 *
 *  - `children`: an array of DIV elements with the attributes "name" and "id".
 *    "name" will be the label of the nav item/section. "id" will be the key of
 *    the section.
 *
 * ## Layout
 *
 * The arrangement of the Table of Contents and the Main Content is controlled
 * via the Bootstrap grid. The column span of the Table of Contents is
 * set via the `navClass` prop, and the column span of the Main Content is set
 * via the 'contentClass' prop.
 *
 * Additionally, if there is a fixed navbar at the top of the page, set the
 * prop `placement` to "auth" for authenticated navbar, "public" for the public
 * navbar, or "consumer" for the consumer navbar. This will ensure there is space
 * when scrolling so the scrollspy is never behind the navbar on desktop or mobile.
 * Without the `placement` prop, the ScrollSpy component will scroll to the top
 * of the page, which is great for the simple navbar, or on pages where no nav
 * bar is present.
 */
const ScrollSpy = _ref => {
  let {
    behavior,
    children,
    navClass,
    contentClass,
    placement
  } = _ref;
  const [select, setSelect] = (0, _react.useState)(false);
  const sectionsWrapperRef = (0, _react.useRef)();
  const scrollspyRef = (0, _react.useRef)();
  const sectionsRefs = {};
  const menuItems = _react.default.Children.toArray(children);
  menuItems.forEach(section => sectionsRefs[section?.props['data-id']] = /*#__PURE__*/(0, _react.createRef)());
  const scrollToTarget = e => {
    e.preventDefault();
    const refName = e?.currentTarget?.dataset.spyId;
    sectionsRefs[refName].current.scrollIntoView({
      behavior: behavior
    });
    setSelect(!select);
  };

  // will scroll to target once user tab to nav and press enter
  const handleEnterKeyPress = e => {
    if (e.key === 'Enter') {
      scrollToTarget(e);
    }
  };
  const classHolder = document.createElement('div');
  classHolder.classList.add('row', 'mm-scrollspy', 'main');
  addPlacementClass(classHolder, placement);

  // sectionWrapperRef to store current viewing section.

  return /*#__PURE__*/_react.default.createElement(_ScrollSection.default, {
    sectionsWrapperRef: sectionsWrapperRef,
    scrollspyRef: scrollspyRef
  }, (currentSection, isVisible) => /*#__PURE__*/_react.default.createElement("div", {
    className: classHolder.classList.value,
    ref: scrollspyRef
  }, /*#__PURE__*/_react.default.createElement("button", {
    "aria-label": "Expand Jump Links",
    "aria-expanded": select,
    className: `btn btn-inline mm-scrollspy-btn-expand ${isVisible ? '' : 'hide'} ${select ? 'select' : ''}`,
    onClick: () => setSelect(!select)
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-caret-spin-down"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: navClass
  }, /*#__PURE__*/_react.default.createElement(_TableOfContents.default, {
    menuItems: menuItems,
    onClick: scrollToTarget,
    onKeyPress: handleEnterKeyPress,
    sectionId: currentSection,
    isVisible: isVisible,
    select: select
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: `asideContent ${contentClass}`,
    ref: sectionsWrapperRef
  }, /*#__PURE__*/_react.default.createElement(_MainContent.default, {
    menuItems: menuItems,
    sectionsRefs: sectionsRefs
  }))));
};
ScrollSpy.defaultProps = {
  behavior: 'smooth',
  contentClass: 'col-12 col-md-9',
  placement: 'none',
  navClass: 'col-3'
};
ScrollSpy.propTypes = {
  /**
   * Should the scrolling be 'smooth' or 'auto'?
   */
  behavior: _propTypes.default.oneOf(['smooth', 'auto']),
  /**
   * The content of the ScrollSpy component.
   */
  children: _propTypes.default.node.isRequired,
  /**
   * CSS class for the *right* content column. Default to 'col-12 col-md-9'
   */
  contentClass: _propTypes.default.string,
  /** This component should consider it's placement relative to this kind of Navbar. */
  placement: _propTypes.default.oneOf(['auth', 'public', 'consumer', 'none']),
  /** css class for the *left* nav column.  Default to 'col-md-3'. */
  navClass: _propTypes.default.string
};
var _default = exports.default = ScrollSpy;